<script>
import TablePage from '../../../../components/table_page';
import Form from '../../../process/components/process_approve/approve.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      tablePage: {
        pageSize: 8,
      },
      configs: {
        pagination: false,
        tableConfig: {
          border: 'inner',
        },
      },
      params: {
        pageNum: 1,
        pageSize: 15,

      },
      isCalculateHeight: false,
    };
  },
  created() {
    this.getConfigList('cqhx_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.$router.push({ path: '/tpm_center/pay_center/write_off' });
      }
    },
  },
};
</script>
